(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .controller('ModalNegotiationContentController', ModalNegotiationContentController);

    /** @ngInject */
    function ModalNegotiationContentController(
        $localStorage,
        $scope,
        systemConstants,
        SalesFunnelService,
        TagService,
        moment,
        toastr,
        $translate,
        Principal,
        $uibModal,
        MODAL_CONTENT_TYPES
    ) {
        var vm = this;
        var storeId = $localStorage.defaultStore.storeId;
        const DATE_FORMAT = $translate.instant('momentDateFormat');

        vm.$onInit = init;

        vm.submit = submit;

        vm.createCustomer = function (typedName) {
            vm.$openSideMenu(typedName);
        };

        vm.$openSideMenu = function (typedName) {
            return $uibModal.open({
                templateUrl: 'app/components/modal/side-modal/side-modal.html',
                controller: 'SideModalController',
                windowClass: 'side-modal z-index-2051',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    content: function () {
                        return {
                            title: $translate.instant('global.form.createCustomer'),
                            cancelButtonText:$translate.instant('global.messages.remove.cancel'),
                            confirmButtonText:$translate.instant('communication.create'),
                            customer: {
                                fullName: typedName
                            },
                            type: MODAL_CONTENT_TYPES.CUSTOMER
                        }
                    }
                }
            }).result.then(function (customer) {
                if (!customer || !customer.id) return;
                vm.selectedCustomer = customer;
                getNegotiationTitle(customer);
            });
        };


        vm.negotiation = undefined;
        vm.selectedProduct = null;
        vm.selectedCustomer = null;
        vm.sellerInput = '';
        vm.customerInput = '';
        vm.isImmoContext = $localStorage.defaultStore.immoContext;
        vm.searchQuery = '';
        vm.newTagText = "";
        vm.tags = [];
        vm.storeTags = [];
        vm.filteredStoreTags = [];

        vm.isFormInvalid = function () {
            return vm.negotiationForm && vm.negotiationForm.$invalid;
        };

        vm.isLoadingNegotiation = false;
        vm.isLoadingSeller = false;

        vm.onChangeStatus = function (newValue) {
            vm.newStatus = newValue;
        };

        vm.changeCustomer = function (value) {
            if (value) {
                vm.customerInput = value.trim();
            } else {
                vm.customerInput = null;
            }
        };

        vm.selectCustomer = function (item) {
            if (item) {
                vm.selectedCustomer = item.originalObject;
                getNegotiationTitle(item.originalObject);
            }
        };

        vm.removeCustomer = function () {
            vm.selectedCustomer = null;
        };

        vm.changeSeller = function (value) {
            if (value) {
                vm.sellerInput = value.trim();
            } else {
                vm.sellerInput = null;
            }
        };

        vm.onChangeProduct = function (value) {
            if (value) {
                vm.selectedProduct = value;
            } else {
                vm.selectedProduct = null;
            }

            if (vm.negotiation && !vm.negotiation.id) {
                if (value && value.detail) {
                    $scope.$applyAsync(function () {
                        if (vm.negotiationForm.salesPrice && (!vm.negotiationForm.salesPrice.$dirty || !vm.negotiationForm.salesPrice.$touched)) {
                            if (value.detail.discountedValue) {
                                vm.negotiation.salesPrice = value.detail.discountedValue;
                            } else {
                                vm.negotiation.salesPrice = value.detail.purchaseValue;
                            }
                        }
                    });
                }
            }

            validateProductsToSave();
        };

        vm.selectSeller = function (item) {
            if (item) {
                vm.selectedSeller = item.originalObject.originalObject;
            }
        };

        vm.requestParams = function (query) {
            return {
                page: 0,
                size: 10,
                storeId: storeId,
                search: query,
            };
        };

        vm.responseFormatter = function(response) {
            return response.map(function (item) {
                return {
                    titleField: item.fullName,
                    descriptionField: vm.getProfileName(item),
                    originalObject: item
                };
            });
        };

        function validateProductsToSave() {
            if (vm.selectedProduct) {
                if (vm.isImmoContext) {
                    vm.isValid =
                        vm.selectedProduct.detail &&
                        vm.selectedProduct.detail.unit;
                } else {
                    vm.isValid =
                        vm.selectedProduct.detail &&
                        vm.selectedProduct.detail.size;
                }
            } else {
                vm.isValid = true;
            }
        }

        vm.getProfileName = function(seller) {
            if (seller.profilesName === systemConstants.STORE_ADMIN_ACCOUNT) {
                return $translate.instant("salesFunnel.negotiation.admin-user");
            }
            return seller.profilesName ? seller.profilesName : '';
        };

        vm.deleteNegotiation = function () {
            if (vm.negotiationId) {
                SalesFunnelService.deleteNegotiation(vm.negotiationId)
                    .then(function () {
                        var stage = vm.column ? vm.column : getSalesFunnelStage(vm.negotiationId, vm.columns);

                        if (stage) {
                            const index = stage.negotiations.findIndex(function (negotiation) {
                                return negotiation.id === itemId;
                            });

                            if (index !== -1) {
                                stage.negotiations.splice(index, 1);
                            }
                        }

                        toastr.success(
                            $translate.instant(
                                "salesFunnel.success.deletedNegotiation"
                            )
                        );

                        var cleanResponse = {
                            deleted: true,
                            negotiationId: vm.negotiationId,
                        }
                        angular.copy(cleanResponse, vm.response);
                    })
                    .catch(function (error) {
                        toastr.error(error.message);
                    });
            }
        };
        vm.removeSeller = function () {
            vm.selectedSeller = null;
            vm.negotiation.sellerId = null;
            vm.negotiation.seller = null;
        }

        function init() {
            if (vm.negotiationId) {
                vm.isLoadingNegotiation = true;
                SalesFunnelService.getNegotiation(vm.negotiationId).then(onSuccessGetNegotiation, onErrorGetNegotiation);
            } else {
                vm.negotiation = {};
                Principal.identity().then(function(account) {
                    vm.selectedSeller = account;
                });
            }
            vm.today = moment().format(DATE_FORMAT);
        }

        function getNegotiationTitle (item) {
            if (!vm.negotiation.title) {
                const fullName = item && item.fullName || "";
                const firstName = fullName.split(" ", 1)[0];
                vm.negotiation.title = $translate.instant("salesFunnel.negotiation.negotiation-of") + " " + firstName;
            }
        }

        function onSuccessGetNegotiation(negotiation) {
            vm.negotiation = negotiation.data;
            if (vm.negotiation) {
                if (
                    vm.isImmoContext &&
                    vm.negotiation.product &&
                    vm.negotiation.product.details &&
                    vm.negotiation.product.details.length > 0 &&
                    vm.negotiation.unit
                ) {
                    var detailByUnit = vm.negotiation.product.details.find(function (detail) {
                        return detail && detail.unit && detail.unit === vm.negotiation.unit;
                    });

                    if (detailByUnit) {
                        vm.negotiation.product.detail = detailByUnit;
                    }
                }
                vm.selectedProduct = vm.negotiation.product || null;
                vm.selectedCustomer = vm.negotiation.customer || null;
                vm.selectedSeller = vm.negotiation.seller || null;

                vm.negotiationEvents = vm.negotiation.events ? vm.negotiation.events.filter(function (event) {
                    var hasChanges = angular.isString(event.changeLog) && event.changeLog.length > 0;
                    var emptyUpdate = false;
                    if (hasChanges) {
                        var changes = JSON.parse(event.changeLog).changes;
                        if (Object.keys(changes).length === 1) {
                            emptyUpdate = changes['updatedBy'] || changes['updatedDate'];
                        } else if (Object.keys(changes).length === 2) {
                            emptyUpdate = changes['updatedBy'] && changes['updatedDate'];
                        }
                    }
                    return hasChanges && !emptyUpdate;
                }).sort(function (a, b) {
                    return b.id - a.id;
                }) : [];

                vm.closedDate = vm.negotiation.closedDate ? moment(vm.negotiation.closedDate).format(DATE_FORMAT) : undefined;
            }
            vm.isLoadingNegotiation = false;
        }

        function onErrorGetNegotiation() {
            toastr.error($translate.instant('salesFunnel.error.errorFetchingNegotiation'));
            vm.isLoadingNegotiation = false;
        }

        function getProductFormatted() {
            var product = vm.selectedProduct;
            if (product) {
                product = vm.selectedProduct.flyer;
                product.detail = vm.selectedProduct.detail;
                if (vm.isImmoContext) {
                    product.color = null;
                }
                if(!vm.isImmoContext && vm.selectedProduct.color && vm.selectedProduct.details && vm.selectedProduct.details.length > 0) {
                    product.color = vm.selectedProduct.details.find(function (color) {
                        return color.id === vm.selectedProduct.color.id;
                    }).color;
                }
            }
            return product;
        }


        function submit() {
            if (vm.submitLoading) return;
            vm.submitLoading = true;

            if (vm.negotiationForm.$invalid) {
                toastr.warning($translate.instant("error.invalid-fields"));
                angular.forEach(vm.negotiationForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    });
                });
                vm.submitLoading = false;
                return;
            }

            if (vm.negotiation.title && vm.selectedCustomer) {
                vm.negotiation.sellerId = vm.selectedSeller
                    ? parseInt(vm.selectedSeller.id)
                    : null;
                vm.negotiation.customerId = vm.selectedCustomer.id;
                vm.negotiation.product = getProductFormatted();

                vm.stage = vm.column ? vm.column : getSalesFunnelStage(vm.negotiationId, vm.columns);

                vm.negotiation.position =
                    vm.stage.negotiations.length > 0
                        ? vm.stage.negotiations.length
                        : 1;

                vm.negotiation.closedDate = vm.closedDate ?
                    moment(vm.closedDate, DATE_FORMAT).toDate() : null;
                vm.negotiation.closed = vm.negotiation.closed ? vm.negotiation.closed : false;

                if (vm.negotiation.id) {
                    if (vm.newStatus) {
                        vm.negotiation.salesFunnelStageId = vm.newStatus.id;
                        vm.negotiation.position = 1;
                    }
                    SalesFunnelService.updateNegotiation(vm.negotiation.id, vm.negotiation)
                        .then(onSuccess)
                        .catch(onError);
                } else {
                    vm.negotiation.salesFunnelStageId = vm.stage.id;
                    vm.negotiation.negotiationDate = new Date().toISOString();
                    SalesFunnelService.addNegotiation(vm.negotiation)
                        .then(onSuccess)
                        .catch(onError);
                }
            }
        }

        function onSuccess(response) {
            vm.submitLoading = false;
            toastr.success(
                $translate.instant(
                    vm.negotiation.id
                        ? "salesFunnel.success.updatedNegotiation"
                        : "salesFunnel.success.createdNegotiation"
                )
            );

            angular.copy(response.data, vm.response);

            const updatedNegotiation = response.data;

            if (vm.newStatus) {
                vm.stage.negotiations = vm.stage.negotiations.filter(function (n) {
                    return n.id !== updatedNegotiation.id;
                });

                vm.stage.negotiations.forEach(function (n, i) {
                    n.position = i + 1;
                });

                const newStage = vm.columns.find(function (col) {
                    return col.id === vm.newStatus.id;
                });

                if (newStage) {
                    updatedNegotiation.position = 1;

                    newStage.negotiations.forEach(function (n) {
                        n.position = n.position + 1;
                    });

                    newStage.negotiations.unshift(updatedNegotiation);
                }

                vm.stage = newStage;

            } else {
                const currentIndex = vm.stage.negotiations.findIndex(function (n) {
                    return n.id === updatedNegotiation.id;
                });

                var newNegotiationsList;

                if (currentIndex !== -1) {
                    newNegotiationsList = vm.stage.negotiations.slice();
                    newNegotiationsList[currentIndex] = updatedNegotiation;
                } else {
                    newNegotiationsList = vm.stage.negotiations.slice();
                    newNegotiationsList.push(updatedNegotiation);
                }

                newNegotiationsList.forEach(function (n, i) {
                    n.position = i + 1;
                });

                vm.stage.negotiations = newNegotiationsList;
            }
        }


        function onError(error) {
            vm.submitLoading = false;
            if (
                error.data &&
                error.data.data &&
                error.data.data.fieldErrors &&
                error.data.data.fieldErrors.length > 0 &&
                error.data.data.fieldErrors[0].message === "Size"
            ) {
                toastr.error(
                    $translate.instant("salesFunnel.error.exceedsCharLimitError")
                );
            } else {
                toastr.error(
                    $translate.instant(
                        vm.negotiation.id
                            ? "salesFunnel.error.errorUpdatingNegotiation"
                            : "salesFunnel.error.errorCreatingNegotiation"
                    )
                );
            }
        }

        function normalizeText(text) {
            return text
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase();
        }

        vm.querySearchTag = function (query) {
            if (!query || query.trim() === '') {
                return [];
            }

            var searchTerm = normalizeText(query.trim());

            return TagService.findTags(searchTerm)
                .then(function (response) {
                    return response || [];
                })
                .catch(function (error) {
                    console.error(error);
                    return [];
                });
        };

        vm.createUpdateTag = function (newNoteTagText, isTag) {
            TagService.createTag({
                text: newNoteTagText
            }).then(function (result) {
                result.timestamp = moment(result.timestamp).format(DATETIME_FORMAT);

                if (isTag) {
                    vm.tags.push(result);
                    vm.newTagText = "";
                } else {
                    vm.notes.push(result);
                    vm.newNoteText = "";
                }
            });
        };

        vm.addTag = function (newTagText) {
            if (!newTagText || newTagText.trim() === "") {
                toastr.warning($translate.instant('entity.validation.blank-text'));
                return;
            }

            var trimmedText = newTagText.trim();

            var newTag = {
                text: trimmedText
            };

            TagService.createTag(newTag)
                .then(function (response) {

                    vm.tags.push(response);

                    if (vm.negotiation.tags) {
                        if (!vm.tagAlreadySelected(response)) {
                            vm.negotiation.tags.push(response);
                        }
                    } else {
                        vm.negotiation.tags = vm.tags;
                        vm.searchQuery = '';
                    }
                    vm.newTagText = "";

                    vm.searchQuery = "";
                })
                .catch(function (error) {
                    toastr.error($translate.instant('entity.action.error-creating'));
                })
                .finally(function () {
                    var inputElement = document.querySelector('md-autocomplete input');
                    if (inputElement) {
                        inputElement.blur();
                    }
                });
        };

        vm.removeTag = function (tagId) {
            var tagIndex = vm.negotiation.tags.findIndex(function (tag) {
                return tag.id === tagId;
            });
            vm.negotiation.tags.splice(tagIndex, 1);
        };

        vm.onSelectTag = function(selectedTag) {
            var inputElement = document.querySelector('md-autocomplete input');
            if (selectedTag) {
                if (vm.negotiation.tags) {
                    vm.negotiation.tags.push(selectedTag);
                    vm.searchQuery = '';
                } else {
                    vm.negotiation.tags = vm.tags;
                    vm.negotiation.tags.push(selectedTag);
                    vm.searchQuery = '';
                }
                if (inputElement) {
                    inputElement.blur();
                }
            }
        };

        vm.tagAlreadySelected = function (tag) {
            if (!vm.negotiation || !vm.negotiation.tags || !tag) {
                return false;
            }

            return vm.negotiation.tags.some(function (existingTag) {
                return existingTag.id === tag.id;
            });
        };
    }
})();
